import useApiQuery from 'shared/hooks/use-api-query';
import addressesKeys from '../util/addresses-keys';
import {AddressProps} from '../types';

const useSearchAddress = (search?: string) => {
  return useApiQuery<AddressProps[]>({
    url: `/addresses/forward-geocoding?address=${search}`,
    queryKey: addressesKeys.search(search!),
    enabled: !!search,
  });
};

export default useSearchAddress;
